module.exports = __WEBPACK_EXTERNAL_MODULE_ieee754__;